import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { PricingPlanDetails } from 'src/features/pricingPlans/types';

const RESOURCE = '/parkings/:parkingId/pricing-plans/details/:planId';

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    planId: number;
}

const queryFn = ({ parkingId, planId, ...params }: DTO): Promise<PricingPlanDetails> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, planId }), { params });
};

interface UseQueryHookOptions {
    config?: QueryConfig<QueryFnType>;
    planId: number | null;
    parkingId: string;
}

const useQueryHook = ({ config, ...params }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, params],
        queryFn: params.planId ? async () => await queryFn(params as DTO) : undefined,
        ...config,
    });

export {
    RESOURCE as GET_PRICING_PLAN_DETAILS,
    queryFn as getPricingPlanDetails,
    useQueryHook as useGetPricingPlanDetails,
};
